import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetPreRegisterConsult,
	GetPreRegisterConsultParams,
	GetPreRegisterConsultResponse,
} from 'domain/usecases/others/facial-biometric/';

export class RemoteFacialBiometricGetPreRegisterConsult implements GetPreRegisterConsult {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetPreRegisterConsultResponse>,
	) {}

	async get(params: GetPreRegisterConsultParams): Promise<GetPreRegisterConsultResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
